/**
 * Searchable Owner Select
 *
 * Provides search/filter functionality for owner selection dropdowns
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all searchable owner inputs
  const searchInputs = document.querySelectorAll('.searchable-owner-input');

  searchInputs.forEach(function(searchInput) {
    const targetId = searchInput.dataset.target;
    const selectElement = document.getElementById(targetId);

    if (!selectElement) {
      return;
    }

    searchInput.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase().trim();
      const options = selectElement.options;

      for (let i = 0; i < options.length; i++) {
        const option = options[i];

        // Always show the "None" option
        if (option.value === '') {
          option.style.display = '';
          continue;
        }

        const username = (option.dataset.username || '').toLowerCase();
        const email = (option.dataset.email || '').toLowerCase();
        const text = (option.textContent || '').toLowerCase();

        // Show if no search term or if it matches
        if (!searchTerm || username.includes(searchTerm) || email.includes(searchTerm) || text.includes(searchTerm)) {
          option.style.display = '';
        } else {
          option.style.display = 'none';
        }
      }
    });
  });
});
